import { createSlice } from '@reduxjs/toolkit';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { INIT_LOCAL__user_auth_logout } from './auth/LOCAL__user_auth_logout';
import { INIT_LOCAL__user_auth_set_open_page_after_login } from './auth/LOCAL__user_auth_set_open_page_after_login';
import { INIT_REMOTE__user_auth_login_with_email_and_password } from './auth/login/REMOTE__user_auth_login_with_email_and_password';
import { init_remote_user_auth_login_with_magic_link_token } from './auth/login/remote_user_auth_login_with_magic_link_token';
import { init_remote_user_auth_login_with_token } from './auth/login/remote_user_auth_login_with_token';
import { init_remote_user_auth_provider_discord_unlink } from './auth/providers/remote_user_auth_provider_discord_unlink';
import { init_remote_user_auth_provider_facebook_unlink } from './auth/providers/remote_user_auth_provider_facebook_unlink';
import { init_remote_user_auth_provider_github_unlink } from './auth/providers/remote_user_auth_provider_github_unlink';
import { init_remote_user_auth_provider_google_unlink } from './auth/providers/remote_user_auth_provider_google_unlink';
import { init_remote_user_auth_provider_microsoft_unlink } from './auth/providers/remote_user_auth_provider_microsoft_unlink';
import { init_remote_user_auth_logout } from './auth/remote_user_auth_logout';
import { init_remote_user_auth_magic_link_generate } from './auth/remote_user_auth_magic_link_generate';
import { init_remote_user_auth_auth_verify_email } from './auth/remote_user_auth_verify_email';
import { init_local_user_settings_upsert } from './settings/local_user_settings_upsert';
import { init_remote_settings_user_update } from './settings/REMOTE__user_settings_update';
import { init_remote_user_settings_update_avatar } from './settings/remote_user_settings_update_avatar';
import { init_remote_user_settings_update_name } from './settings/remote_user_settings_update_name';
import { int_remote_user_settings_update_password } from './settings/remote_user_settings_update_password';
import { slice_user_initial_state } from './slice_user_initial_state';
import { init_local_user_tutorial_progress_on_sent_to_server } from './tutorial/local_user_tutorial_progress_on_sent_to_server';
import { init_local_user_tutorial_progress_upsert } from './tutorial/local_user_tutorial_progress_upsert';

export const slice_user = createSlice({
  name: ENUM__redux_slice.USER,

  initialState: slice_user_initial_state,

  reducers: {
    auth_logout: INIT_LOCAL__user_auth_logout,
    auth_set_page_after_login: INIT_LOCAL__user_auth_set_open_page_after_login,

    settings_upsert: init_local_user_settings_upsert,

    tutorial_upsert: init_local_user_tutorial_progress_upsert,
    tutorial_on_sent_to_server: init_local_user_tutorial_progress_on_sent_to_server,
  },

  extraReducers: builder => {
    init_remote_user_auth_magic_link_generate(builder);

    INIT_REMOTE__user_auth_login_with_email_and_password(builder);
    init_remote_user_auth_login_with_token(builder);
    init_remote_user_auth_auth_verify_email(builder);

    init_remote_user_auth_provider_google_unlink(builder);
    init_remote_user_auth_provider_microsoft_unlink(builder);
    init_remote_user_auth_provider_github_unlink(builder);
    init_remote_user_auth_provider_discord_unlink(builder);
    init_remote_user_auth_provider_facebook_unlink(builder);

    init_remote_user_auth_login_with_magic_link_token(builder);
    init_remote_user_auth_logout(builder);

    init_remote_settings_user_update(builder);

    init_remote_user_settings_update_name(builder);
    init_remote_user_settings_update_avatar(builder);

    int_remote_user_settings_update_password(builder);

    builder.addCase(LOCAL__global_reset, state => {
      let { regional_language } = state.user_settings;

      let out = {
        ...slice_user_initial_state,
        user_id: state.user_id,
        auth_token: state.auth_token,
        settings: DTO__user_settings.CLIENT_DEFAULT.clone({ regional_language }),
      };

      return out;
    });
  },
});
